<template lang="pug">
  #CustomerReservationModel.CustomerModel.CustomerModel-reservationModel.p-3(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .row.align-items-start.mb-2
      .col-10
        h2.mb-0 {{ title }}
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .container
      .d-flex.align-items-center.justify-content-center
        div(style="letter-spacing: 5px; font-weight: bold; font-size: 1.2rem; margin-bottom: 5px;") 建立預約
      .d-flex.align-items-center.justify-content-center(style="flex-direction: column;")
        input.inputStyle(
          type='text', placeholder="請輸入姓名" v-model='userInfo.name')
        input.inputStyle(
          type='text', placeholder="請輸入行動電話" v-model='userInfo.mobile')
      .multiselect_custom_homePage
        multiselect(
          label="name",
          tracy-by="activity_reserve_store_id"
          placeholder="請選擇活動",
          :options="activityDropdown",
          :searchable="false",
          :allow-empty="false",
          v-model="userInfo.selectedStore",
          selectLabel='',
          deselect-label='',
          @input='getActivityTimeList'
          noOptions="無可選擇活動"
        )
          template(slot="noOptions")
            strong 無可選擇活動
      .multiselect_custom_homePage
        multiselect(
          track-by="activity_start_at",
          label="activity_start_at",
          placeholder="請選擇活動日期",
          :options="activityTimeList",
          :searchable="false",
          :allow-empty="false",
          v-model="userInfo.selectedDate",
          selectLabel='',
          deselect-label='',
          @input='getStoreActivitySession'
          noOptions="無可選擇日期"
        )
          template(slot="noOptions")
            strong 無可選擇日期
      .multiselect_custom_homePage
        multiselect(
          track-by="id",
          label="period_limit",
          placeholder="請選擇活動時段",
          :options="activitySessionList",
          :searchable="false",
          :allow-empty="false",
          v-model="userInfo.selectedTime",
          selectLabel='',
          deselect-label='',
          noOptions="無可選擇時段"
        )
          template(slot="noOptions")
            strong 無可選擇時段
      button.btn.btn-primary.mt-4.mb-3(type="button", @click="goItemList()", style="width: 100%;")
        span(style="margin-right: 10px;") 送出
</template>

<script>
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import { mapState } from 'vuex';
import { required } from 'vee-validate/dist/rules';

const moment = require('moment');
const _ = require('lodash');

export default {
  name: 'EventActivityModel',
  props: {
    title: {
      type: String,
      default: ''
    },
    user: {
      type: [Object, null]
    },
    memberInfo: {
      type: [Object, null]
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      form: {
        name: null,
        service: null,
        date: null,
        timeId: null,
        saNote: null
      },
      dateMinLimit: moment().format(),


      couponList: [],
      testStoreOptions: [{ id: 1, store: '台北101店' }, { id: 2, store: '台中遠百店' }],
      actInfo: {
        title: '活動主題活動主題',
        content: '活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明活動說明',
        actImg: 'https://images.chinatimes.com/newsphoto/2017-03-17/1024/20170317005512.jpg',
        hint: ['1. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。', '2. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。', '3. 此活動預約須預授權扣款1,000元，金額將於活動結束後取消授權扣款。'],
        actDateList: ['2021/12/01', '2021/12/02', '2021/12/03'],
        actDateTimeList: ['11:00', '14:00', '17:00']
      },
      userInfo: {},
      agreeUseRule: [],
      activitySessionList: [],
      isSend: false,
    };
  },
  mounted() {
    this.$EventBus.$on('openEventActivityModel', () => {
      this.openModel();
    });
  },
  methods: {
    moment() {
      return moment();
    },
    initHandler() {
      const vm = this;
      vm.userInfo = {
        name: vm.memberInfo.chinese_last_name + vm.memberInfo.chinese_first_name,
        mobile: vm.memberInfo.mobile ? vm.memberInfo.mobile : '',
        saNote: null
      };
    },
    openModel() {
      this.initHandler();
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.initHandler();
      this.showModel = false;
    },
    goItemList() {
      const vm = this;
      const MobileReg = /^(09)[0-9]{8}$/;
      if (!vm.userInfo.name) {
        vm.$swal.fire({
          title: '請輸入姓名',
          icon: 'info'
        });
      } else if (!vm.userInfo.mobile) {
        vm.$swal.fire({
          title: '請輸入行動電話',
          icon: 'info'
        });
      } else if (!MobileReg.test(vm.userInfo.mobile)) {
        vm.$swal.fire({
          title: '行動電話格式錯誤',
          icon: 'info'
        });
      } else if (!vm.userInfo.selectedTime) {
        vm.$swal.fire({
          title: '請選擇活動時段',
          icon: 'info'
        });
      } else {
        if (vm.isSend) return;
        vm.isSend = true;

        vm.$swal.fire({
          title: '資料送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        const data = {
          activity_reserve_detail_id: vm.userInfo.selectedTime.id,
          line_uuid: vm.user.member_uuid,
          meta: {
            name: vm.userInfo.name,
            mobile: vm.userInfo.mobile
          }
        };

        vm.$store.dispatch('sa_event_activity/sendEventActivityHandler', data).then(() => {
          vm.$swal.close();
          vm.$snotify.success(null, '活動預約建立成功');
          vm.isSend = false;
          vm.closeModel();
        }).catch(() => {
          vm.isSend = false;
        });
      }
    },
    getActivityTimeList(val) {
      const vm = this;
      vm.$set(vm.userInfo, 'selectedDate', null);
      vm.$set(vm.userInfo, 'selectedTime', null);
      vm.$store.commit('sa_event_activity/setActivityTimeList', []);
      vm.$set(vm, 'activitySessionList', []);
      this.$nextTick(function () {
        vm.$swal.fire({
          title: '取得日期時段中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });
        vm.$store.dispatch('sa_event_activity/getActivityTimeListHandler', val.activity_reserve_store_id).then(() => {
          vm.$swal.close();
        });
      });
    },
    getStoreActivitySession(val) {
      const vm = this;
      vm.activitySessionList = val.activity_detail;
    },
    isChecked(index) {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.invite_id === vm.invitations[index].invite_id);
      if (key) {
        return true;
      }
      return false;
    }
  },
  computed: {
    ...mapState({
      activityDropdown: (state) => state.sa_event_activity.activityDropdown,
      activityTimeList: (state) => state.sa_event_activity.activityTimeList,
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('openReservationModel');
  }
};
</script>

<style lang="scss" scoped>
  .line {
    border-top: solid 1px #aaa;
    width: 100%;
    height: 1px;
  }

  .container {
    padding: 35px 20px;
    text-align: left;
  }

  .inputStyle {
    width: 100%;
    padding: 15px;
    text-align: center;
    margin: 5px;
    border: none;
    background: #eee;
  }
  .footer {
    border-top: solid #aaa 1px;
    padding: 20px;
  }
  .multiselect_custom_homePage {
    padding: 5px 0;
    & .multiselect__placeholder {
      color: #828282;
      margin-left: 20px;
      font-size: 1rem;
    }
    & .multiselect__tags {
      border: solid #888 1px;
      border-radius: 3px;
      min-height: 55px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    & .multiselect__input, .multiselect__single {
      text-align: center;
    }
    & .multiselect__select {
      top: 9px;
    }
    & .multiselect__content-wrapper {
      text-align: center;
    }
  }
</style>
